import React, { useEffect, useState } from 'react';
import { Wrapper, Menu, Button, MenuItem } from 'react-aria-menubutton';
import styled from 'styled-components/macro';
import ArrowIcon from '../components/svg/Arrow';
import { getIdHistorico, getUrl, parseaFechaHora } from '../utils';
import { useTranslate } from '../contexts/languageContext';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useMesa, useSetViewContext } from '../contexts/viewContext';
import constantes from '../resources/constantes.json';

/**
 * Dropdown que nos permite acceder a la página de histórico para el ámbito en el que nos encontremos
 */

const Dropdown = ({
  data,
  items,
  id,
  eleccion,
  ambito,
  nomenclator,
  className = '',
  defaultSelectedId,
  hasSelectedItem,
  openOnMount,
  page,
  tope,
  parentLevel,
  date,
  hideMenu = false,
}) => {
  const [isOpen, setIsOpen] = useState(openOnMount);
  const { mesa } = useMesa();
  const setViewContext = useSetViewContext();
  const esBoletin = tope === '1';
  const t = useTranslate();
  const isMobile = useIsMobile();
  const filtered = [];

  if (items && items.length !== 0) {
    for (let i = 0; i < items.length; i++) {
      const found = filtered.findIndex(item => item.numact === items[i].numact);
      if (found !== -1) {
        if (Number(items[i].mdhm) > Number(filtered[found].mdhm))
          filtered[found] = items[i];
      } else {
        filtered.push(items[i]);
      }
    }
  }
  const [hora, fecha] = parseaFechaHora(data.mdhm).split(' - ');
  return filtered && filtered.length !== 0 ? (
    <StyledWrapper
      /* onSelection={({
        id,
        eleccion,
        nomenclator,
        page,
        idHistorico,
        parentLevel,
        item,
        tope,
      }) => {
        window.open(
          getUrl({
            id,
            eleccion,
            nomenclator,
            page,
            idHistorico,
            parentLevel,
          }),
          'newwindow'
        );
      }} */
      onMenuToggle={({ isOpen }) => setIsOpen(isOpen)}
    >
      <StyledButton
        tabIndex={hideMenu ? '-1' : '0'}
        style={{ backgroundColor: isOpen ? '#00000024' : '#215CCC' }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            {console.log(
              'a: ',
              eleccion === constantes.eleccion.jal
                ? constantes.level.puesto
                : constantes.level.comuna
            )}
            {ambito.l <
            (eleccion === constantes.eleccion.jal
              ? constantes.level.puesto
              : constantes.level.comuna)
              ? `${esBoletin ? t('boletin') : t('avance')} ${data.numact}`
              : 'boletin 9999'}
          </span>
          {!date && (
            <DateSpan>
              <span style={{ fontWeight: '700' }}>{hora}</span>{' '}
              <span style={{ fontWeight: '400' }}>{fecha}</span>
            </DateSpan>
          )}
        </div>

        <ContainerArrow>
          <ArrowIcon
            css="padding-left: 10px"
            variant={isOpen ? 'up' : 'down'}
            fill={isMobile ? '#ffffff' : '#fff'}
          />
        </ContainerArrow>
      </StyledButton>
      <StyledMenu
        style={{ scale: hideMenu ? 0 : 1, transformOrigin: 'top right' }}
      >
        <Title>
          {esBoletin ? t('historicoDeBoletines') : t('historicoDeAvances')}
        </Title>
        <Ul>
          {filtered.map(item => {
            const idHistorico = getIdHistorico(item.numdep, tope);
            return (
              <li key={item.numact}>
                <SMenuItem
                  value={{
                    id,
                    eleccion,
                    nomenclator,
                    page,
                    idHistorico,
                    item,
                    parentLevel,
                  }}
                  text={item.numact}
                >
                  <StyledAnchor
                    /* target="_blank"
                    rel="noopener noreferrer"
                    href={getUrl({
                      id,
                      eleccion,
                      nomenclator,
                      page,
                      idHistorico,
                      parentLevel,
                    })} */
                    onClick={e => {
                      e.preventDefault();
                      setViewContext(s => ({
                        ...s,
                        modalHistoricos: {
                          ...s.modalHistoricos,
                          open: true,
                          url: getUrl({
                            id,
                            eleccion,
                            nomenclator,
                            page,
                            idHistorico,
                            parentLevel,
                          }),
                        },
                      }));
                    }}
                    tabIndex="-1"
                  >
                    <span style={{ color: '#215CCC' }}>
                      {`${esBoletin ? t('boletin') : t('avance')} ${
                        item.numact
                      } - `}
                    </span>
                    <span style={{ color: '#E40424', fontWeight: 700 }}>
                      {`${parseaFechaHora(item.mdhm).split('-')[0]}`}
                    </span>
                    <span style={{ color: '#164192' }}>
                      {`${parseaFechaHora(item.mdhm).split('-')[1]}`}
                    </span>
                  </StyledAnchor>
                </SMenuItem>
              </li>
            );
          })}
        </Ul>
      </StyledMenu>
    </StyledWrapper>
  ) : (
    <StyledText>
      <span
        style={{
          backgroundColor: '#00000024',
          borderRadius: '25px',
          padding: '7px',
        }}
      >
        {ambito.l <
          (eleccion === constantes.eleccion.jal
            ? constantes.level.puesto
            : constantes.level.comuna) && !mesa
          ? `${esBoletin ? t('boletin') : t('avance')} ${data.numact}`
          : 'boletin 9999'}
      </span>
    </StyledText>
  );
};
export default Dropdown;

const Title = styled.div`
  font-weight: 700;
  color: #164192;
`;
const StyledWrapper = styled(Wrapper)`
  position: relative;
  box-sizing: border-box;
  display: flex;
  min-width: 130px;
  max-width: 150px;
  flex-grow: 0;
  @media (max-width: 1024px) {
    margin-left: auto;
    width: 100%;
    justify-content: flex-start;
  }
`;

const StyledMenu = styled(Menu)`
  position: absolute;
  z-index: 21;
  top: 70px;
  background: white;
  padding: 20px;
  box-sizing: border-box;
  left: -134px;
  min-width: 250px;
  max-height: 250px;
  border-radius: 20px;
  border: 2px solid #d8dfea;
  ::before {
    content: '';
    display: inline-block;
    position: absolute;
    left: calc(50% + 55px);
    top: -20px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent white;
    z-index: 6;
    @media (max-width: 768px) {
      right: 20px;
      left: initial;
    }
  }
  ::after {
    content: '';
    display: inline-block;
    position: absolute;
    left: calc(50% + 55px);
    top: -23px;
    border-width: 11px;
    border-style: solid;
    border-color: transparent transparent #d8dfea;
    z-index: 5;
    @media (max-width: 768px) {
      right: 20px;
      left: initial;
    }
  }
  @media (max-width: 768px) {
    max-height: 235px;
    max-width: 90vw;
    right: 20px;
    left: initial;
  }
`;

const Ul = styled.ul`
  overflow: auto;
  background: white;
  box-sizing: border-box;
  max-height: 195px;
  @media (max-width: 768px) {
    max-height: 175px;
  }
`;

const StyledButton = styled(Button)`
  font-weight: 100;
  font-size: 16px;
  text-transform: camelCase;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  line-height: 1.3;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  justify-content: center;
  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
  padding: 14px;
  border-radius: 25px;
  @media screen and (max-width: 1023px) {
    font-size: 1rem;
    margin-top: 0.4rem;
    border-radius: 40px 0px 0px 40px;
    padding-top: 6px;
    padding-bottom: 7px;
    flex-direction: row-reverse;
  }
`;

const StyledAnchor = styled.button`
  display: block;
  width: 100%;
  line-height: 2em;
`;
const StyledText = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  max-width: 200px;
  @media (max-width: 1023px) {
    margin-left: auto;
  }
`;
const ContainerArrow = styled.span`
  @media print {
    display: none;
  }
  @media screen and (max-width: 1023px) {
    align-self: flex-start;
    justify-self: flex-start;
    margin-left: 0;
    margin-right: 1rem;
    margin-top: auto;
    margin-bottom: auto;
  }
`;

const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  font-size: 12px;
  border-bottom: 1px solid #d8dfea;
  margin-right: 2rem;
  > a {
    color: #283f5f;
  }
  @media (max-width: 768px) {
    padding: 5px 0;
  }

  &.focus-visible {
    text-decoration: underline !important;
    outline: none !important;
  }
  :hover {
    a {
      text-decoration: underline;
    }
  }
`;

const DateSpan = styled.span`
  display: none;
  white-space: nowrap;
  @media screen and (max-width: 1023px) {
    display: block;
  }
`;
